import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Pricing from './pages/Pricing';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import './App.css';
import SchoolLanding from './pages/School';
import CafeLanding from './pages/Cafe';
import AstrologerSiteLanding from './pages/AstrologerSite';
import PhotographerSiteLanding from './pages/PhotographerSite';
import EventManagementSiteLanding from './pages/EventManagementSite';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/school" element={<SchoolLanding />} />
        <Route path="/school/:schoolSlug" element={<SchoolLanding />} />
        <Route path="/cafe" element={<CafeLanding />} />
        <Route path="/cafe/:cafeSlug" element={<CafeLanding />} />
        <Route path="/astrologer-site" element={<AstrologerSiteLanding />} />
        <Route path="/photographer-site" element={<PhotographerSiteLanding />} />
        <Route path="/event-management-site" element={<EventManagementSiteLanding />} />
        <Route path="/" element={
          <Layout>
            <Home />
          </Layout>
        } />
        <Route path="/home" element={
          <Layout>
            <Home />
          </Layout>
        } />
        <Route path="/about" element={
          <Layout>
            <About />
          </Layout>
        } />
        <Route path="/services" element={
          <Layout>
            <Services />
          </Layout>
        } />
        <Route path="/services/:serviceType" element={
          <Layout>
            <ServiceDetail />
          </Layout>
        } />
        <Route path="/pricing" element={
          <Layout>
            <Pricing />
          </Layout>
        } />
        <Route path="/portfolio" element={
          <Layout>
            <Portfolio />
          </Layout>
        } />
        <Route path="/contact" element={
          <Layout>
            <Contact />
          </Layout>
        } />
        <Route path="*" element={
          <Layout>
            <NotFound />
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
